import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Classical_Antiquity_-_Ancient_Greece.png';

function HistoryPageHellenisticGo() {
  return (
    <QuizPage
      title="History: Hellenistic World"
      subTopic="Hellenistic World"
      backgroundImage={historyImage}
      returnPath="/History-Hellenistic-World"
    />
  );
}

export default HistoryPageHellenisticGo;   


